<script setup lang="ts">
const items = [
  {
    title: 'Banyak Akun Dipakai Bersama',
    description:
      'Data penting rawan terhapus atau tertimpa karena tidak ada pembagian akses yang jelas antar anggota tim.',
    icon: 'material-symbols:groups-outline'
  },
  {
    title: 'Salah Input',
    description:
      'Kesalahan kecil saat memasukkan data bisa menyebabkan keterlambatan proses COD dan gangguan pada alur operasional.',
    icon: 'material-symbols:edit-off-outline'
  },
  {
    title: 'Unidentified',
    description:
      'Sulit melacak siapa yang mengerjakan apa, membuat tanggung jawab tidak jelas dan evaluasi kerja jadi terhambat.',
    icon: 'material-symbols:help-outline'
  }
]

const { isMobile } = useBreakpoints()
</script>

<template>
  <UiSectionWrapper
    image-class="lg:order-first"
    title="Saat Tim Bertambah, Resiko Human Error Juga Naik"
    hero-image="/images/manajemen-staff-banner-2.webp"
    class="py-12"
  >
    <template #action>
      <div class="mt-6 lg:mt-12 flex flex-col gap-6 text-lg leading-7">
        <div
          v-for="(item, index) in items"
          :key="index"
          class="flex items-start gap-3"
        >
          <div
            class="p-2 rounded-full bg-primary-container flex-none text-primary"
          >
            <Icon :name="item.icon" :size="isMobile ? '22px' : '30px'" />
          </div>
          <div class="flex-1 flex flex-col gap-2">
            <p class="text-sm lg:text-xl font-bold lg:font-semibold">
              {{ item.title }}
            </p>
            <p class="text-sm lg:text-base text-outline">
              {{ item.description }}
            </p>
          </div>
        </div>
      </div>
    </template>
  </UiSectionWrapper>
</template>
